import { combineReducers } from "redux";

import user from "./user";
import main from "./main";
import report from "./report";

export default combineReducers({
  user,
  main,
  report,
});
